import React, { Component } from 'react';
import PropTypes from 'prop-types';

/**
 * This is a static react port of the cdc template 5 https logo svg
 */

export default class HttpsIcon extends Component {
    render() {
        const { className } = this.props;
        return (
            <svg className={className} width="64" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_31_4)">
                    <path d="M34.72 34.84C34.72 35.1821 34.5841 35.5102 34.3422 35.7522C34.1002 35.9941 33.7721 36.13 33.43 36.13H20.57C20.2279 36.13 19.8998 35.9941 19.6578 35.7522C19.4159 35.5102 19.28 35.1821 19.28 34.84V27.12C19.28 26.7779 19.4159 26.4498 19.6578 26.2078C19.8998 25.9659 20.2279 25.83 20.57 25.83H21V23.26C21 21.6687 21.6321 20.1426 22.7574 19.0174C23.8826 17.8921 25.4087 17.26 27 17.26C28.5913 17.26 30.1174 17.8921 31.2426 19.0174C32.3679 20.1426 33 21.6687 33 23.26V25.83H33.43C33.7721 25.83 34.1002 25.9659 34.3422 26.2078C34.5841 26.4498 34.72 26.7779 34.72 27.12V34.84ZM30.43 25.84V23.26C30.43 22.3503 30.0686 21.4779 29.4254 20.8346C28.7821 20.1914 27.9097 19.83 27 19.83C26.0903 19.83 25.2179 20.1914 24.5746 20.8346C23.9314 21.4779 23.57 22.3503 23.57 23.26V25.83H30.43V25.84Z" fill="#549500" />
                    <path d="M27 53.12C41.3594 53.12 53 41.4794 53 27.12C53 12.7606 41.3594 1.12 27 1.12C12.6406 1.12 1 12.7606 1 27.12C1 41.4794 12.6406 53.12 27 53.12Z" stroke="#458600" strokeMiterlimit="10" />
                </g>
                <defs>
                    <clipPath id="clip0_31_4">
                        <rect width="54" height="54" fill="white" />
                    </clipPath>
                </defs>
            </svg>


        )
    }

}

HttpsIcon.propTypes = {
    className: PropTypes.string
}